<template>
  <div class="report">
    <navbar v-model="sidebar"></navbar>
    <sidebar v-model="sidebar"></sidebar>

    <b-card id="report-form" no-body>
      <b-tabs pills card vertical v-model="page">
        <b-tab active>
          <template slot="title">
            <font-awesome-icon icon="table"/>  Informazioni generali
          </template>

          <b-table striped hover show-empty stacked="md" :items="reportList" :fields="reportFields" :current-page="currentPage" :per-page="perPage">
            <template slot="actions" slot-scope="row">
              <b-button size="sm" variant="info" @click.stop="infoReportModal(row.item)" style="margin-left: 5px">
                <font-awesome-icon icon="info-circle" />
              </b-button>
              <b-button size="sm" v-if="row.item.editable" @click.stop="editReport(row.item)" style="margin-left: 5px">
                <font-awesome-icon icon="edit" />
              </b-button>
              <b-button size="sm" v-if="row.item.editable" variant="danger" @click.stop="deleteReportModal(row.item)" style="margin-left: 5px">
                <font-awesome-icon icon="trash-alt" />
              </b-button>
            </template>
          </b-table>

          <b-row>
            <b-col></b-col>
            <b-col>
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
            </b-col>
            <b-col></b-col>
          </b-row>

          <b-button size="lg" variant="success" v-on:click="disabled = false" :disabled="!disabled" style="float: right; margin-top: 50px">
            <div class="spinner">
              <p v-if="!disabled">Creazione report in corso</p>
              <p v-else>Crea nuovo Report</p>
              <div class="bounce1" v-if="!disabled"></div>
              <div class="bounce2" v-if="!disabled"></div>
              <div class="bounce3" v-if="!disabled"></div>
            </div>
          </b-button>
        </b-tab>
        <b-tab :disabled="disabled">
          <template slot="title">
            <button class="numberCircle" :disabled="disabled">1</button> Ricavi
          </template>
          <b-form-textarea :rows="5" :max-rows="8" v-model="report.ricavi" placeholder="Analisi dei ricavi"></b-form-textarea>
          <apexcharts type="bar" :options="chartOptions" :series="series" style="float: left; width: 50%"></apexcharts>
          <b-table striped hover :items="items" :fields="fields" style="float: right; width: calc(50% - 100px); margin-top: 50px; margin-left: 50px; margin-right: 50px;"></b-table>
        </b-tab>
        <b-tab :disabled="disabled">
          <template slot="title">
            <button class="numberCircle" :disabled="disabled">2</button> Utile
          </template>
          <b-form-textarea :rows="5" :max-rows="8" v-model="report.utile" placeholder="Analisi dell'utile"></b-form-textarea>
          <apexcharts type="bar" :options="chartOptions" :series="series" style="float: left; width: 50%"></apexcharts>
          <b-table striped hover :items="items" :fields="fields" style="float: right; width: calc(50% - 100px); margin-top: 50px; margin-left: 50px; margin-right: 50px;"></b-table>        </b-tab>
        <b-tab :disabled="disabled">
          <template slot="title">
            <button class="numberCircle" :disabled="disabled">3</button> Costo
          </template>
          <b-form-textarea :rows="5" :max-rows="8" v-model="report.costo" placeholder="Analisi del costo"></b-form-textarea>
          <apexcharts type="bar" :options="chartOptions" :series="series" style="float: left; width: 50%"></apexcharts>
          <b-table striped hover :items="items" :fields="fields" style="float: right; width: calc(50% - 100px); margin-top: 50px; margin-left: 50px; margin-right: 50px;"></b-table>        </b-tab>
        <b-tab :disabled="disabled">
          <template slot="title">
            <button class="numberCircle" :disabled="disabled">4</button> Locazione
          </template>
          <b-form-textarea :rows="5" :max-rows="8" v-model="report.locazione" placeholder="Analisi della locazione"></b-form-textarea>
          <apexcharts type="bar" :options="chartOptions" :series="series" style="float: left; width: 50%"></apexcharts>
          <b-table striped hover :items="items" :fields="fields" style="float: right; width: calc(50% - 100px); margin-top: 50px; margin-left: 50px; margin-right: 50px;"></b-table>        </b-tab>
        <b-tab :disabled="disabled">
          <template slot="title">
            <button class="numberCircle" :disabled="disabled">5</button> Personale
          </template>
          <b-form-textarea :rows="5" :max-rows="8" v-model="report.personale" placeholder="Analisi del personale"></b-form-textarea>
          <apexcharts type="bar" :options="chartOptions" :series="series" style="float: left; width: 50%"></apexcharts>
          <b-table striped hover :items="items" :fields="fields" style="float: right; width: calc(50% - 100px); margin-top: 50px; margin-left: 50px; margin-right: 50px;"></b-table>        </b-tab>
        <b-tab :disabled="disabled">
          <template slot="title">
            <button class="numberCircle" :disabled="disabled">6</button> Utenze
          </template>
          <b-form-textarea :rows="5" :max-rows="8" v-model="report.utenze" placeholder="Analisi delle utenze"></b-form-textarea>
          <apexcharts type="bar" :options="chartOptions" :series="series" style="float: left; width: 50%"></apexcharts>
          <b-table striped hover :items="items" :fields="fields" style="float: right; width: calc(50% - 100px); margin-top: 50px; margin-left: 50px; margin-right: 50px;"></b-table>        </b-tab>
        <b-tab :disabled="disabled">
          <template slot="title">
            <button class="numberCircle" :disabled="disabled">7</button> ROL
          </template>
          <b-form-textarea :rows="5" :max-rows="8" v-model="report.rol" placeholder="Analisi del ROL"></b-form-textarea>
          <apexcharts type="bar" :options="chartOptions" :series="series" style="float: left; width: 50%"></apexcharts>
          <b-table striped hover :items="items" :fields="fields" style="float: right; width: calc(50% - 100px); margin-top: 50px; margin-left: 50px; margin-right: 50px;"></b-table>        </b-tab>
        <b-tab :disabled="disabled">
          <template slot="title">
            <font-awesome-icon icon="file-alt"/>  Riepilogo
          </template>
          <b-row>
            <b-col>
              <h6>Ricavi:</h6>
              <b-form-textarea :rows="4" :max-rows="4" v-model="report.ricavi" disabled></b-form-textarea>
            </b-col>
            <b-col>
              <h6>Utile:</h6>
              <b-form-textarea :rows="4" :max-rows="4" v-model="report.utile" disabled></b-form-textarea>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col>
              <h6>Costo:</h6>
              <b-form-textarea :rows="4" :max-rows="4" v-model="report.costo" disabled></b-form-textarea>
            </b-col>
            <b-col>
              <h6>Locazione:</h6>
              <b-form-textarea :rows="4" :max-rows="4" v-model="report.locazione" disabled></b-form-textarea>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col>
              <h6>Personale:</h6>
              <b-form-textarea :rows="4" :max-rows="4" v-model="report.personale" disabled></b-form-textarea>
            </b-col>
            <b-col>
              <h6>Utenze:</h6>
              <b-form-textarea :rows="4" :max-rows="4" v-model="report.utenze" disabled></b-form-textarea>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col>
              <h6>ROL:</h6>
              <b-form-textarea :rows="4" :max-rows="4" v-model="report.rol" disabled></b-form-textarea>
            </b-col>
            <b-col>
              <b-button size="lg" variant="success" v-on:click="clearReport()" style="float:right; margin-top: 90px; margin-right: 30px;" v-if="disabled">Torna indietro</b-button>
            </b-col>
          </b-row>          
        </b-tab>
      </b-tabs>
    </b-card>

    <div class="text-center" v-if="!disabled">
      <b-button-group class="mt-2"  style="float:center; margin-left: 20%">
        <b-btn @click="page--" v-if="page != 0">Indietro</b-btn>
        <b-btn @click="page++" v-if="page != 8">Avanti</b-btn>
      </b-button-group>

      <b-button-group class="mt-2" style="float:right; margin-right: 50px">
        <b-btn variant="outline-danger" v-if="page != 0" v-on:click="clearReport()">Cancella</b-btn>
        <b-btn variant="success" v-if="page == 8" v-on:click="saveReport()">Salva</b-btn>
      </b-button-group>
    </div>

    <b-modal v-model="modal.delete" size="sm" title="Eliminare report?">
      Proseguire con l'eliminazione del report?
      <div slot="modal-footer" class="w-100">
        <b-button variant="secondary" style="float: right; margin-left: 10px;" v-on:click="modal.delete = false">No</b-button>
        <b-button variant="danger" style="float: right;" v-on:click="deleteReport(modalData.delete.id)">Si</b-button>
      </div>
    </b-modal>

    <b-modal v-model="modal.alertFiltri" size="sm" title="Cambiare filtri?">
      <p>Per cambiare i filtri bisogna chiudere e cancellare l'attuale report, perdendo ogni informazione e/o modifica effettuata e creare un nuovo report.</p>
      <p><strong>ATTENZIONE: Si perderà ogni informazione!!</strong></p>
      <p>Proseguire?</p>
      <div slot="modal-footer" class="w-100">
        <b-button variant="success" style="float: right; margin-left: 10px;" v-on:click="modal.alertFiltri = false">No</b-button>
        <b-button variant="warning" style="float: right;" v-on:click="modal.alertFiltri = false" @click="clearReport()">Si</b-button>
      </div>
    </b-modal>

    <b-modal v-model="modal.info" size="lg" title="Informazioni sul report">
      <h3>Commenti</h3>
      <h6>Ricavi:</h6>
      <b-form-textarea :rows="2" :max-rows="2" v-model="modalData.info.ricavi" disabled></b-form-textarea>
      <h6>Utile:</h6>
      <b-form-textarea :rows="2" :max-rows="2" v-model="modalData.info.utile" disabled></b-form-textarea>
      <h6>Costo:</h6>
      <b-form-textarea :rows="2" :max-rows="2" v-model="modalData.info.costo" disabled></b-form-textarea>
      <h6>Locazione:</h6>
      <b-form-textarea :rows="2" :max-rows="2" v-model="modalData.info.locazione" disabled></b-form-textarea>
      <h6>Personale:</h6>
      <b-form-textarea :rows="2" :max-rows="2" v-model="modalData.info.personale" disabled></b-form-textarea>
      <h6>Utenze:</h6>
      <b-form-textarea :rows="2" :max-rows="2" v-model="modalData.info.utenze" disabled></b-form-textarea>
      <h6>ROL:</h6>
      <b-form-textarea :rows="2" :max-rows="2" v-model="modalData.info.rol" disabled></b-form-textarea>
      
      <div slot="modal-footer" class="w-100">
        <div style="float: left;">
          <p style="margin-bottom: 0">Autore: {{modalData.info.nome}} {{modalData.info.cognome}}</p>
          <p style="margin-bottom: 0">Creato il: {{modalData.info.data}}</p>
        </div>
        <b-button variant="secondary" style="float: right; margin-left: 10px;" v-on:click="modal.info = false">Chiudi</b-button>
        <b-button variant="info" style="float: right; margin-left: 10px" v-on:click="anteprima(modalData.info)"><font-awesome-icon icon="file-pdf" /> Anteprima</b-button>
        <b-button variant="success" style="float: right; margin-left: 10px" v-on:click="scarica(modalData.info)"><font-awesome-icon icon="file-download" /> Scarica</b-button>
        <b-form-radio-group buttons button-variant="outline-primary" style="float: right;" v-model="lingua_r" :options="[{ text: 'Italiano', value: 'italiano' }, { text: 'Tedesco', value: 'tedesco' }]"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import navbar from '@/components/navbar.vue'
import sidebar from '@/components/sidebar.vue'
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'report',
  components: {
    sidebar,
    navbar,
    apexcharts: VueApexCharts
  },
  created: function () {
    this.updateReportList()
  },
  watch: {
    'sidebar.cerca': function (newQuestion, oldQuestion) {
      if(!this.disabled)
        this.modal.alertFiltri = true
    },
    'disabled': function (newQuestion, oldQuestion) {
      if(!newQuestion){
        this.filtra()
      }
    },
    'page': function (newQuestion, oldQuestion) {
      this.pageChart(this.page)
    },
    'sidebar.stato': function (newQuestion, oldQuestion) {
      setTimeout(this.setCategories, 200, this.categories)
    },
    'sidebar.cercaAziende': function (newQuestion, oldQuestion) {
      this.filtraAziende()
    }
  },
  data() {
    return {
      sidebar: this.$sidebar,
      page: 0,
      disabled: true,
      report: {
        ricavi: '',
        utile: '',
        costo: '',
        locazione: '',
        personale: '',
        utenze: '',
        rol: ''
      },
      //inizio chart
      chartOptions: {
        chart: {
          id: 'vuechart-example',
          width: '100%'
        },
        xaxis: {
          categories: []
        },
        colors: ['#008FFB', '#00E396', '#FF4560']
      },
      series: [{
        name: 'Valore',
        data: [30, 40]
      }],//fine chart

      allSeries: [],
      sidebarBackup: {},
      reportList: [],
      reportFields: [
        { key: 'zona', label: 'Zona', sortable: true },
        { key: 'azienda', label: 'Azienda', sortable: true },
        { key: 'categoria', label: 'Categoria', sortable: true },
        { key: 'sottocategoria', label: 'Sottocategoria', sortable: true },
        { key: 'range', label: 'Ricavi', sortable: true },
        { key: 'periodo', label: 'Periodo', sortable: true },
        { key: 'actions', label: '' }
      ],
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      modal: {
        delete: false,
        info: false,
        alertFiltri: false
      },
      modalData: {
        delete: {},
        info: {}
      },
      reportEdited: false,
      //inizio tabella
      fields: [],
      items: [],
      //fine tabella

      categories: [],

      lingua_r: 'italiano',

    }
  },
  methods: {
    filtra(){
      var data 
      
      if(this.reportEdited)
        data = this.sidebarBackup
      else{
        data = {
          zona: this.$sidebarValue.zona,
          anno1: this.$sidebarValue.anno1,
          anno2: this.$sidebarValue.anno2,
          trimestre1: this.$sidebarValue.trimestre1,
          trimestre2: this.$sidebarValue.trimestre2,
          categoria: this.$sidebarValue.categoria,
          sottocategoria: this.$sidebarValue.sottocategoria,
          ricavi: this.$sidebarValue.ricavi,
          criterio: this.$sidebarValue.criterio,
          azienda: this.$sidebarValue.azienda
        }

        this.sidebarBackup = data
      }

      Vue.http.post(this.$hostlink+'report/filtro', data, {credentials : true}).then(response => {
        Vue.prototype.$sidebarValue.info = response.body.info
        this.setCategories(response.body.data.categories)
        this.categories = response.body.data.categories
        this.allSeries = response.body.data.series
        this.page = 1
      })
    },
    filtraAziende(){
      var data = {
        zona: this.$sidebarValue.zona,
        anno1: this.$sidebarValue.anno1,
        anno2: this.$sidebarValue.anno2,
        trimestre1: this.$sidebarValue.trimestre1,
        trimestre2: this.$sidebarValue.trimestre2,
        categoria: this.$sidebarValue.categoria,
        sottocategoria: this.$sidebarValue.sottocategoria,
        ricavi: this.$sidebarValue.ricavi,
        criterio: this.$sidebarValue.criterio
      }

      Vue.http.post(this.$hostlink+'report/filtro/aziende', data, {credentials : true}).then(response => {
        Vue.prototype.$sidebarValue.listaAziende = response.body
        
        Vue.prototype.$sidebar.trovatoAziende = !this.$sidebar.trovatoAziende
        this.$emit('input', this.$sidebar)
      })
    },
    setCategories(categories){
      this.chartOptions = {
        chart: {
          id: 'chart',
          width: '100%'
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
          categories: categories
        },
        colors: ['#008FFB', '#00E396', '#FF4560']
      }

      this.fields = [{ key: 'zona', label: 'Zona', sortable: true }]
      for(var i=0; i<categories.length; i++){
        this.fields.push({ key: 'v'+(i+1), label: categories[i], sortable: true })
      }
    },
    pageChart(page){
      var nome

      switch(page) {
        case 1:
          nome = "ricavi"
          break
        case 2:
          nome = "utile"
          break
        case 3:
          nome = "costo"
          break
        case 4:
          nome = "locazione"
          break
        case 5:
          nome = "personale"
          break
        case 6:
          nome = "utenze"
          break
        case 7:
          nome = "rol"
          break
      }

      var data = []
      this.series = []
      this.items = []
      
      //carico dati da tutte le zone
      if(this.allSeries.tutto.length > 0){
        for(var i=0; i<this.allSeries.tutto.length; i++){
          if(this.getCategoria(this.allSeries.tutto[i].anno, this.allSeries.tutto[i].trimestre) != this.categories[i]){
            if(this.allSeries.tutto.length > 1)
              console.log("ECCEZZIONE da visualizzare!!")
            else
              data.push(0)
          }

          data.push(Number(parseFloat(Number(this.allSeries.tutto[i][nome])).toFixed(2)))
          
          if(this.getCategoria(this.allSeries.tutto[i].anno, this.allSeries.tutto[i].trimestre) == this.categories[i] && this.categories.length > this.allSeries.tutto.length){
            if(this.allSeries.tutto.length > 1)
              console.log("ECCEZZIONE da visualizzare!!")
            else
              data.push(0)
          }
        }

        //dati tabella
        if(this.categories.length > 1)
          this.items.push({zona: this.allSeries.tutto[0].zona, v1: data[0]+(nome != "ricavi" ? "%" : ""), v2: data[1]+(nome != "ricavi" ? "%" : "")})
        else
          this.items.push({zona: this.allSeries.tutto[0].zona, v1: data[0]+(nome != "ricavi" ? "%" : "")})

        //dati grafico
        this.series.push({
          name: this.allSeries.tutto[0].zona,
          data: data
        })

        data = []
      }

      //carico dati zona
      if(this.allSeries.zona.length > 0){
        for(var i=0; i<this.allSeries.zona.length; i++){
          if(this.getCategoria(this.allSeries.zona[i].anno, this.allSeries.zona[i].trimestre) != this.categories[i]){
            if(this.allSeries.zona.length > 1)
              console.log("ECCEZZIONE da visualizzare!!")
            else
              data.push(0)
          }

          data.push(Number(parseFloat(Number(this.allSeries.zona[i][nome])).toFixed(2)))

          if(this.getCategoria(this.allSeries.zona[i].anno, this.allSeries.zona[i].trimestre) == this.categories[i] && this.categories.length > this.allSeries.zona.length){
            if(this.allSeries.zona.length > 1)
              console.log("ECCEZZIONE da visualizzare!!")
            else
              data.push(0)
          }
        }

        //dati tabella
        if(this.categories.length > 1)
          this.items.push({zona: this.allSeries.zona[0].zona, v1: data[0]+(nome != "ricavi" ? "%" : ""), v2: data[1]+(nome != "ricavi" ? "%" : "")})
        else
          this.items.push({zona: this.allSeries.zona[0].zona, v1: data[0]+(nome != "ricavi" ? "%" : "")})

        //dati grafico
        this.series.push({
          name: this.allSeries.zona[0].zona,
          data: data
        })

        data = []
      }

      //carico dati da azienda
      if(this.allSeries.azienda.length > 0){
        for(var i=0; i<this.allSeries.azienda.length; i++){
          if(this.getCategoria(this.allSeries.azienda[i].anno, this.allSeries.azienda[i].trimestre) != this.categories[i]){
            if(this.allSeries.azienda.length > 1)
              console.log("ECCEZZIONE da visualizzare!!")
            else
              data.push(0)
          }

          data.push(Number(parseFloat(Number(this.allSeries.azienda[i][nome])).toFixed(2)))

          if(this.getCategoria(this.allSeries.azienda[i].anno, this.allSeries.azienda[i].trimestre) == this.categories[i] && this.categories.length > this.allSeries.azienda.length){
            if(this.allSeries.azienda.length > 1)
              console.log("ECCEZZIONE da visualizzare!!")
            else
              data.push(0)
          }
        }

        //dati tabella
        if(this.categories.length > 1)
          this.items.push({zona: this.allSeries.azienda[0].zona, v1: data[0]+(nome != "ricavi" ? "%" : ""), v2: data[1]+(nome != "ricavi" ? "%" : "")})
        else
          this.items.push({zona: this.allSeries.azienda[0].zona, v1: data[0]+(nome != "ricavi" ? "%" : "")})

        //dati grafico
        this.series.push({
          name: this.allSeries.azienda[0].zona,
          data: data
        })

        data = []
      }
    },
    clearReport(){
      this.page = 0
      this.disabled = true
      this.report = {
        ricavi: '',
        utile: '',
        costo: '',
        locazione: '',
        personale: '',
        utenze: '',
        rol: ''
      }

      this.reportEdited = false
      this.updateReportList()
    },
    saveReport(){
      var data = this.report
      data.filtri = this.sidebarBackup

      if(this.reportEdited){
        data.id = this.reportEdited
        Vue.http.post(this.$hostlink+'report/update', data, {credentials : true}).then(response => {
          if(response.body.success){
            this.disabled = true
            this.reportEdited = false
            Vue.notify({
              group: 'global',
              title: 'Operazione eseguita',
              text: 'Report aggiornato con successo!',
              type: 'success'
            })
          }else{
            Vue.notify({
              group: 'global',
              title: 'Errore durante la modifica!',
              text: response.body.msg,
              type: 'error'
            })
          }
        }, response => {
          Vue.notify({
            group: 'global',
            title: 'Errore di comunicazione',
            text: 'Errore di comunicazione con i server!',
            type: 'error'
          })
        })
      }else{
        Vue.http.post(this.$hostlink+'report/add', data, {credentials : true}).then(response => {
          if(response.body.success){
            this.disabled = true
            Vue.notify({
              group: 'global',
              title: 'Operazione eseguita',
              text: 'Report creato con successo!',
              type: 'success'
            })
          }else{
            Vue.notify({
              group: 'global',
              title: 'Errore durante la creazione!',
              text: response.body.msg,
              type: 'error'
            })
          }
        }, response => {
          Vue.notify({
            group: 'global',
            title: 'Errore di comunicazione',
            text: 'Errore di comunicazione con i server!',
            type: 'error'
          })
        })
      }
    },
    updateReportList(){
      Vue.http.post(this.$hostlink+'report/list', {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.totalRows = response.body.data.length
          this.reportList = []
          for(var i=0; i<this.totalRows; i++){
            var x = response.body.data[i]
            //x = Object.assign({}, x, JSON.parse(x.filtri))
            var filtri = JSON.parse(x.filtri)
            x.data = new Date(Date.parse(x.data)).toLocaleString('it-IT')
            x.periodo = this.getPeriodo(filtri.anno1, filtri.anno2, filtri.trimestre1, filtri.trimestre2)
            x.range = this.getRicavi(filtri.trimestre1, filtri.ricavi)
            if(!x.zona)
              x.zona = "Tutte le zone"

            this.reportList.push(x)
          }
        }else{
          Vue.notify({
            group: 'global',
            title: 'Errore durante il caricamento!',
            text: response.body.msg,
            type: 'error'
          })
        }
      }, response => {
        Vue.notify({
          group: 'global',
          title: 'Errore di comunicazione',
          text: 'Errore di comunicazione con i server!',
          type: 'error'
        })
      })
    },
    getPeriodo(anno1, anno2, trimestre1, trimestre2){
      var p1 = null
      if(anno1 && trimestre1){
        p1 = anno1+'/Q'+trimestre1
      }else if(trimestre1){
        p1 = 'Q'+trimestre1
      }else if(anno1){
        p1 = anno1
      }

      var p2 = null
      if(anno2 && trimestre2){
        p2 = anno2+'/Q'+trimestre2
      }else if(trimestre2){
        p2 = 'Q'+trimestre2
      }else if(anno2){
        p2 = anno2
      }

      if(p1 && p2)
        return p1+" : "+p2
      if(p1)
        return p1
      if(p2)
        return p2
    },
    getRicavi(trimestre, ricavi){
      if(trimestre == null)
        trimestre = 1
      
      var ricaviString = [ this.formatNumber(2500.00*trimestre)+' - '+this.formatNumber(25000.00*trimestre),
          this.formatNumber(25000.00*trimestre)+' - '+this.formatNumber(50000.00*trimestre),
          this.formatNumber(50000.00*trimestre)+' in su']
      if(ricavi)
        return ricaviString[ricavi]
      return ''
    },
    formatNumber(n){
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(n)
    },
    deleteReportModal(report){
      this.modalData.delete = report
      this.modal.delete = true
    },
    infoReportModal(report){
      this.modalData.info = report
      this.modal.info = true
    },
    deleteReport(id){
      Vue.http.post(this.$hostlink+'report/delete', {id: id}, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione eseguita',
            text: 'Report eliminato con successo!',
            type: 'success'
          })
        }else
          Vue.notify({
            group: 'global',
            title: 'Errore!',
            text: response.body.msg,
            type: 'error'
          })
        this.modal.delete = false
        this.updateReportList()
      }, response => {
        Vue.notify({
          group: 'global',
          title: 'Errore!',
          text: 'Errore durante la comunicazione con il server!',
          type: 'error'
        })
      })
    },
    editReport(report){
      this.report = {
        ricavi: report.ricavi,
        utile: report.utile,
        costo: report.costo,
        locazione: report.locazione,
        personale: report.personale,
        utenze: report.utenze,
        rol: report.rol
      }

      this.sidebarBackup = JSON.parse(report.filtri)
      this.reportEdited = report.id
      this.disabled = false
    },  
    anteprima(report){
      window.open(this.$hostlink+'report/anteprima/'+this.lingua_r+'/'+report.id)
    },  
    scarica(report){
      window.open(this.$hostlink+'report/scarica/'+this.lingua_r+'/'+report.id)
    },
    getCategoria(anno, trimestre){
      if(anno != null && trimestre == null){
        return ""+anno
      }else if(anno == null && trimestre != null){
        return ""+trimestre
      }else if(anno != null && trimestre != null){
        return anno+"-Q"+trimestre
      }
    }
  }
}
</script>


<style>
#report-form{
  height: calc(100vh - 200px);
}

.numberCircle {
  border-radius: 50%;
  /*behavior: url(PIE.htc);*/
  /* remove if you don't care about IE8 */
  width: 24px;
  height: 24px;
  padding: 3px 5px 3px 5px;
  background: #007bff;
  border: 2px solid #f7f7f7;
  color: #f7f7f7;
  text-align: center;
  font: 12px Arial, sans-serif;
}:disabled{
  background: #6c757d;
}


/*CSS loader animated*/
.spinner {
  /*margin: 100px auto 0;*/
  /*width: 70px;*/
  text-align: center;
}

.spinner > div {
  width: 8px;
  height: 8px;
  background-color: white;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner > p {
  margin: 0;
  float: left;
  margin-right: 8px;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% { 
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}
</style>
